/**
 * NoAttributeConditionType - Condition qui vérifie si un attribut n'existe PAS
 * Identique à Flutter NoAttributeConditionType
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';

export class NoAttributeConditionType implements ConditionType {
  typeName = 'COND_NO_ATTRIBUTE';
  messageKey = 'laventurier.condition.no_attribute.name';
  descriptionKey = 'laventurier.condition.no_attribute.desc';
  errorKey = 'laventurier.condition.no_attribute.error';
  hasValue = false;
  hasAttribute = true;

  evaluate(gameState: GameState, condition: any): boolean {
    const attributeId = condition.attribute || condition.attributeId;
    if (!attributeId) {
      // Si pas d'attribut recherché, la condition est remplie
      return true;
    }

    const searchedAttrId = attributeId.toString();

    // Vérifier dans objects
    for (const obj of gameState.data.objects) {
      if (obj.attributeId.toString() === searchedAttrId && obj.dropped === 0) {
        return false; // L'attribut est présent et non lâché
      }
    }

    // Vérifier dans skills
    for (const skill of gameState.data.skills) {
      if (skill.attributeId.toString() === searchedAttrId) {
        return false; // L'attribut est présent
      }
    }

    // Vérifier dans butterflyEffects
    for (const effect of gameState.data.butterflyEffects) {
      if (effect.attributeId.toString() === searchedAttrId) {
        return false; // L'attribut est présent
      }
    }

    // L'attribut n'est pas présent (ou est lâché pour les objects)
    return true;
  }
}
